import React from 'react';
import './index.css';

function NotFoundScreen() {
  return (
    <div className="NotFoundScreen">
      <h1 className="NotFoundScreen-h1">
        not found :[
      </h1>
    </div>
  );
}

export default NotFoundScreen;
